import { render } from "./TheMbDivisionCount.vue?vue&type=template&id=122fb1ca&scoped=true"
import script from "./TheMbDivisionCount.vue?vue&type=script&lang=js"
export * from "./TheMbDivisionCount.vue?vue&type=script&lang=js"

import "./TheMbDivisionCount.vue?vue&type=style&index=0&id=122fb1ca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-122fb1ca"

export default script